<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} vé điện tử chờ duyệt
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="4">
                    <el-form-item label="Tên" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['ve_dien_tu.ten']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain @click="fn_tableSearch()">{{
                    aLang.c_search
                  }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select v-model="mData.tableRules.dataSearch.value.ready" :placeholder="'Trạng thái'"
                    @change="fn_tableSearch()" :default-first-option="true" clearable filterable
                    v-if="this.mData.currentUser.roles.includes('Officer')">
                    <el-option v-for="item in mData.dataDefault.trangThai" :key="item.code" :label="item.text"
                      :value="item.code"></el-option>
                  </el-select>
                </b-col>
                <b-col md="4">
                  <el-select v-model="mData.tableRules.dataSearch.value.ngon_ngu" :placeholder="'Ngôn ngữ'"
                    @change="fn_tableSearch()" :default-first-option="true" clearable filterable
                    v-if="this.mData.currentUser.roles.includes('Officer')">
                    <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
              <el-button @click="fn_handle('create')"
                v-if="mData.currentUser.roles.includes('SafePlace') && mData.ifHavePermission" type="info" plain>{{
                  aLang.c_create_new_post
                }}
              </el-button>
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ve_dien_tu.ten" label="Tên dịch vụ" :sortable="mData.tableRules.allowSorting"
            :width="mData.currentUser.roles.includes('Officer') || mData.currentUser.roles.includes('Admin') ? '350px' : ''">
            <template slot-scope="scope">
              <el-link class="cell-child" target="_blank"
                @click="fn_handle(mData.currentUser.roles.includes('SafePlace') ? 'detail-history' : 'accept', scope.$index, scope.row)"
                :underline="false">{{ scope.row.ve_dien_tu.ten }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="ve_dien_tu.url" label="Link dịch vụ" :sortable="mData.tableRules.allowSorting"
            :width="mData.currentUser.roles.includes('Officer') || mData.currentUser.roles.includes('Admin') ? '370px' : ''">
          </el-table-column>
          <el-table-column prop="don_vi_cung_cap.du_lieu_khai_bao.user_ten" label="Tên đơn vị"
            :sortable="mData.tableRules.allowSorting" width="256px"
            v-if="mData.currentUser.roles.includes('Officer') || mData.currentUser.roles.includes('Admin')">
          </el-table-column>
          <el-table-column prop="don_vi_cung_cap.ve_dien_tu.loai" label="Loại hình"
            :sortable="mData.tableRules.allowSorting" width="150px">
            <template slot-scope="scope">
              <div class="text-center">
                {{
                  scope.row.don_vi_cung_cap.ve_dien_tu.loai == "transport_ticket" ? 'Vé giao thông' :
                    scope.row.don_vi_cung_cap.ve_dien_tu.loai == "show_ticket" ? 'Vé nghệ thuật biểu diễn' : ''
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="duyet.duoc_duyet" label="Trạng thái" :sortable="mData.tableRules.allowSorting"
            width="120px">
            <template slot-scope="scope">
              <div class="text-center">
                <span v-if="scope.row.duyet.duoc_duyet == false">
                  Từ chối
                </span>
                <span v-else>
                  {{
                    scope.row.ready === true
                      ? "Chờ duyệt"
                      : scope.row.ready === false
                        ? "Đang soạn thảo"
                        : "Đang soạn thảo"
                  }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ly_do_tu_choi" label="Ghi chú" width="180px" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" :content="scope.row.ly_do_tu_choi">
                <span>{{
                  scope.row.ly_do_tu_choi
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail-history', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail" v-if="mData.currentUser.roles.includes('SafePlace')">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('accept', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_accept"
                v-if="mData.currentUser.roles.includes('Officer') || mData.currentUser.roles.includes('Admin')">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update-history', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update">
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete">
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <ModalSelectDonViVeDienTu @submit="gotoCreateDonViCungCap" :configModal="mData.showFormAdd" />
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from '@/service/DataService';
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import DichVuChoDuyetApi from '@/moduleApi/DichVuChoDuyetApi';
import MethodService from '../../../service/MethodService';
import DDATApi from '@/moduleApi/DDATApi';
import VeDienTuModel from '@/views/admin/VeDienTu/VeDienTuModel';
import ModalSelectDonViVeDienTu from '@/views/admin/VeDienTu/ModalSelectDonViVeDienTu';

export default {
  components: {
    ModalSelectDonViVeDienTu
  },
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "VeDienTu", //requied
        tableRules: MethodService.copyObject(VeDienTuModel.tableRules),
        dataDefault: {
          trangThai: [
            {
              code: "true",
              text: "Chờ duyệt",
            },
            {
              code: "",
              text: "Tất cả",
            },
          ],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
        showFormAdd: {
          show: false,
        },
      }
    }
  },
  async created() {
    if (
      this.mData.currentUser.roles.includes("Officer") ||
      this.mData.currentUser.roles.includes("Admin")
    ) {
      this.mData.tableRules.dataSearch.value.ready = "true";
    } else {
      this.mData.tableRules.dataSearch.value.ready = "";
    }
    if (this.mData.currentUser.roles.includes("SafePlace")) {
      const ddatRes = await DDATApi.list({
        filters: "nguoi_tao_id=" + this.mData.currentUser.id
      })
      if (ddatRes.result) {
        const donViCungCapRes = await DonViCungCapApi.findById(ddatRes.result[0].id);
        this.mData.ifHavePermission = !(donViCungCapRes.result && (
          donViCungCapRes.result.ve_dien_tu.loai == "air_plain_ticket" ||
          donViCungCapRes.result.ve_dien_tu.loai == "transport_ticket"
        ))
      }
    }
    this.fn_hashUrl();
    this.fn_tableSearchDefault();
    this.$store.commit("fn_countVeDienTu");

  },
  methods: {
    gotoCreateDonViCungCap(DonVi) {
      this.mData.showFormAdd.show = false;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-create-admin",
        params: { id: DonVi.donViCungCapId }
      });
    },
    async getVeDienTuList() {
      let dataFilter = {
        filters: this.mData.tableRules.filters + (this.mData.tableRules.filters ? "&" : "") + "loai=ticket&ve_dien_tu.loai:in:show_ticket"
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-history",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(() => { });
      }

      let res = await DichVuChoDuyetApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);
      let donViCungCapIds = res.result.map(id => id.diem_den_an_toan_id);
      let arrDonViCungCapIds = MethodService.findListItemDifferent(donViCungCapIds);

      let donViCungCapRes = await DonViCungCapApi.list({
        filters: "id:in:" + arrDonViCungCapIds.join(",")
      });
      resData.map(item => {
        item.don_vi_cung_cap = donViCungCapRes.result.find(x => x.id == item.diem_den_an_toan_id)
      })
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getVeDienTuList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getVeDienTuList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getVeDienTuList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    // search
    fn_tableSearchDefault() {
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.getVeDienTuList();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getVeDienTuList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-history",
        query: query
      });
    },

    async fn_handle(type, scope, row) {
      if (type == "create") {
        const apiRes = await DDATApi.list({
          filters: "nguoi_tao_id=" + this.mData.currentUser.id,
          fields: 'merchant'
        })
        if (apiRes.result.length > 0) {
          this.$router.push({
              name: "Admin-" + this.mData.moduleName + "-create"
            });
          // task 186367 bỏ check merchant
          // if (MethodService.checkHaveMerchant(apiRes.result[0])) {
          //   this.$router.push({
          //     name: "Admin-" + this.mData.moduleName + "-create"
          //   });
          // }
        }
      }
      if (type == "create-admin") {
        this.mData.showFormAdd.show = true;
      }
      if (type == "detail-history") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail-history",
          params: { id: row.id }
        });
      }
      if (type == "update-history") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update-history",
          params: { id: row.id }
        });
      }
      if (type == "accept") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-accept",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => { });
      }
    },

    async fn_delete(id) {
      await DichVuChoDuyetApi.delete(id);
      this.$store.commit("fn_countVeDienTu");
      this.getVeDienTuList();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  }
}
</script>

<style scope>
.text-css {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-css p {
  margin: 0;
}
</style>
